"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _school = require("@/api/school/school");
var _user = require("@/api/user/user");
var _validate = require("@/libs/validate1");
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          loginName: [{
            required: true,
            message: "请输入登录账号",
            trigger: "blur"
          }, {
            min: 2,
            max: 15,
            message: "账号长度在2到15个字符",
            trigger: "blur"
          }],
          password: [{
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }, {
            validator: PSWRULE,
            trigger: "blur"
          }],
          userName: [{
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }, {
            min: 2,
            max: 8,
            message: "姓名长度在2到8个字符",
            trigger: "blur"
          }],
          ICCode: [
          // { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            validator: _validate.validateIdNo,
            trigger: "blur"
          }],
          email: [{
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }, {
            validator: _validate.validateEMail,
            trigger: "blur"
          }],
          telNumber: [{
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }, {
            validator: _validate.validatePhoneTwo,
            trigger: "blur"
          }]
        },
        labelWidth: "120px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "登录账号",
          isDisabled: false,
          placeholder: "登录账号",
          prop: "loginName",
          value: "",
          required: true,
          span: 12
        }, {
          type: "input",
          label: "姓名",
          isDisabled: false,
          placeholder: "请输入姓名",
          prop: "userName",
          value: "",
          required: true,
          span: 12
        }, {
          type: "input",
          label: "身份证号",
          isDisabled: false,
          placeholder: "请输入身份证号",
          prop: "ICCode",
          value: "",
          required: true,
          span: 12
        }, {
          type: "input",
          label: "手机号",
          isDisabled: false,
          placeholder: "请输入手机号",
          prop: "telNumber",
          value: "",
          required: true,
          span: 12
        }, {
          type: "input",
          label: "邮箱",
          isDisabled: false,
          placeholder: "请输入邮箱",
          prop: "email",
          value: "",
          span: 12
        }]
      }
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      console.log(e);
      (0, _user.addUser)({
        schoolId: this.$route.query.schoolId,
        name: e.userName,
        phoneNumber: e.telNumber,
        mail: e.email,
        idCard: e.ICCode,
        userType: 2,
        isExpert: 0,
        isPlatUser: 0,
        loginName: e.loginName
      }).then(function (res) {
        if (res.code === 2000) {
          _this.$message.success("操作成功。");
          history.go(-1);
        }
      });
    }
  },
  created: function created() {}
};